<div *ngIf="isActive" class="ig-calendar modern-block h-full">
  <ig-infinite-scroll-container [loadMore]="loadItems" mode="normal"
    [isEvent]="actionCommand.isEventCalendar"></ig-infinite-scroll-container>
  <div></div>
</div>

<div *ngIf="!isActive" class="w-full h-full flex justify-center items-center text-xl">
  This feature is disabled, please contact our team, emailing aline&#64;iti-digital.com or call us at 912-267-1558
</div>
